var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28998 17.9258C8.90722 17.5431 8.90722 16.9225 9.28998 16.5397L13.7219 12.1078L9.28708 7.6729C8.90432 7.29015 8.90432 6.66958 9.28708 6.28682C9.66984 5.90407 10.2904 5.90407 10.6732 6.28682L15.8011 11.4147C15.9849 11.5985 16.0881 11.8478 16.0881 12.1078C16.0881 12.3677 15.9849 12.617 15.8011 12.8008L10.6761 17.9258C10.2933 18.3086 9.67273 18.3086 9.28998 17.9258Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28998 17.9258C8.90722 17.5431 8.90722 16.9225 9.28998 16.5397L13.7219 12.1078L9.28708 7.6729C8.90432 7.29015 8.90432 6.66958 9.28708 6.28682C9.66984 5.90407 10.2904 5.90407 10.6732 6.28682L15.8011 11.4147C15.9849 11.5985 16.0881 11.8478 16.0881 12.1078C16.0881 12.3677 15.9849 12.617 15.8011 12.8008L10.6761 17.9258C10.2933 18.3086 9.67273 18.3086 9.28998 17.9258Z",
    fill: "currentColor",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/RightIcon.6b52887fc1e0cc4fa46c4f431223df59.svg";
export { ForwardRef as ReactComponent };